export interface FloatingVoiceCardDimensions {
  width: string;
  height: string;
}

export function floatingVoiceCardDimensions(
  localScreenShareEnabled: boolean,
): FloatingVoiceCardDimensions {
  return localScreenShareEnabled
    ? { width: "360px", height: "300px" }
    : { width: "320px", height: "178px" };
}
